/**
 * @file    responseFilterOptions.ts
 * @scope   SHARED
 * @summary Maps an AdvancedFilter response to the select option used by every filter editor
 *          (field filters, partition filters) so value types and paths stay consistent.
 * @consumes AdvancedFilterResponseOption
 * @produces `mapResponseToFilterOption`
 * @sideEffects None — pure.
 * @notes Priority: Flag → string flag ('DK'), Rating → number, Id → number, else Choice.
 *        SimpleBoolean true/false conversion happens afterwards in `resolveResponseOptions`.
 */
import { SelectOptions } from 'core-ui/MultipleSelectSortable/MultipleSelectSortable';
import { AdvancedFilterResponseOption } from 'models/WidgetModel';
import { SIMPLE_BOOLEAN_TYPE } from './booleanResponseOptions';

export const mapResponseToFilterOption = (
  r: AdvancedFilterResponseOption,
  typeName?: string
): SelectOptions => {
  const path = r.flag
    ? String(r.flag)
    : r.rating != null
    ? 'rating'
    : typeName === SIMPLE_BOOLEAN_TYPE
    ? ''
    : 'id';
  const value = r.flag
    ? String(r.flag)
    : r.rating != null
    ? Number(r.rating)
    : r.id != null
    ? Number(r.id)
    : r.choice;

  return {
    value,
    label: r.choice,
    longText: r.flag ? `Flag: ${r.flag}` : r.choice,
    raw: r,
    path,
  };
};
